/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../components/auth/auth-constants';
import {RulesetResource} from '../../components/api/resources/resource/ruleset.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-ruleset-route-page',
  template: `
    <adn-ruleset-list-page
      *ngIf="list"
      [list]="list">
    </adn-ruleset-list-page>
  `
})
export class RulesetRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(RulesetResource) private readonly Ruleset: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasAny(PERMISSIONS.managePublishing.apiKey)
      && !this.LocalUserPermissions.hasAny(PERMISSIONS.axPublisher.apiKey);
    this.adnListHelper.setUpList(this.list, this.Ruleset, readOnly, 'fullRulesetList', {
      baseTable: 'ruleset'
    });
  }
}
